/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react'
import FormDuuf, {
  FormDuufGroup,
  FormDuufSubmit,
  useFormDuuf,
} from '@ubo/form-duuf'
import { graphql, useStaticQuery } from 'gatsby'
import { Form, Formik } from 'formik'
import ButtonDefault from 'components/elements/ButtonDefault'
import styled from 'styled-components'
import dayjs from 'dayjs'
import Next from 'img/icon/next.inline.svg'
import { isPossiblePhoneNumber } from 'react-phone-number-input'
import Loading from 'components/shared/Loading'
import ParseContent from 'components/shared/ParseContent'
import Input from './Input'

export { FormDuufGroup, FormDuufSubmit, useFormDuuf }

const StyledButtonDefault = styled(ButtonDefault)`
  & > a,
  & > button,
  & > div {
    padding: 0;
  }
`

const ButtonDefaultSubmit = styled.button`
  color: ${(props) => props.theme.color.text.light};
  background-color: ${(props) => props.theme.color.secondary};
  display: inline-block;
  border-radius: 30px;
  font-weight: ${(props) => props.theme.font.weight.l};
  color: ${(props) => props.theme.color.text.light};

  & > svg {
    margin-left: 15px;

    @media (min-width: 992px) {
      height: 25px;
      width: 25px;
    }

    @media (max-width: 991px) {
      height: 20px;
      width: 20px;
    }
  }

  @media (min-width: 992px) {
    font-size: ${(props) =>
      props.small ? props.theme.font.size.m : props.theme.font.size.xm};
    padding: 12px 35px;
  }

  @media (max-width: 991px) {
    font-size: ${(props) =>
      props.small ? props.theme.font.size.m : props.theme.font.size.m};
    padding: 10px 25px;
  }

  &:hover {
    text-decoration: underline;
  }
`

const LoadingWrapper = styled.div`
  position: relative;
  height: 500px;
`

const FormBox = styled.div`
  border: 1px solid ${(props) => props.theme.color.contrast};
  border-radius: 14px;
  padding: 3rem;

  @media (max-width: 991px) {
    padding: 2rem 0;
  }
`

export const volumeOfShipmentField = `input_10`
export const declaredValueLumpsumField = `input_1`
export const shipmentItemsField = `input_6`
export const totalValueField = `input_11`


const LumpsumForm = ({ id, fields, status, setStatus }) => {
  const { lumpsumforms } = useStaticQuery(graphql`
    query lumpsumformDuufQuery {
      lumpsumforms: allGfForm {
        edges {
          node {
            formId
            slug
            apiURL
            formFields {
              id
              label
              labelPlacement
              type
              isRequired
              visibility
              inputName
              placeholder
              checkboxLabel
              choices
              allowedExtensions
              description
              content
            }
            button {
              text
            }
            confirmations {
              message
            }
          }
        }
      }
    }
  `)

  const { node: form } = lumpsumforms.edges.filter(
    ({ node: { formId } }) => formId === id
  )[0]

  const [data, setData] = useState({})
  const [totalValue, setTotalValue] = useState(0)
  const [message, setMessage] = useState('')

  const setDataLocal = (event) => {
    const newData = { ...data }

    newData[event.target.name] = event.target.value

    setData(newData)
  }

  const handleSubmission = async (values) => {
    const formData = new FormData()

    Object.keys(values).forEach((key) => {
      formData.append(key, values[key])
    })

    try {
      const request = await fetch(`${form.apiURL}/submissions`, {
        method: 'POST',
        body: formData,
      })

      if (!request.ok) {
        throw new Error('Failed to submit the form')
      }      

      setStatus('done')
      setMessage('Thanks for your submission!')

      // if (request.ok) {
      //   setStatus('redirecting')
      //   await request.json()

      //   localStorage.removeItem(`quotation-${id}-step`)
      //   localStorage.removeItem(`quotation-${id}-expanded`)
      //   localStorage.removeItem(`quotation-${id}-data`)

      //   return true
      // }

      // const error = await request.json()
      // await setStatus(error)

      // return false
    } catch (error) {
      console.error('Error submitting form:', error)
      setStatus("error")
      // setStatus('done')
      // setMessage('Thanks for your message.')
    }
  }

  const formFields = {}
  const initialValues = {}
  let formFieldsIndex = 1

  form.formFields.forEach((edges) => {
    if (edges.type === 'section') {
      formFieldsIndex = parseFloat(edges.label.split(' ')[1])
    } else {
      if (!formFields[formFieldsIndex]) {
        formFields[formFieldsIndex] = []
      }

      formFields[formFieldsIndex].push(edges)      
    }
  })


  return (
    <div className="px-lg-4">
      <Formik      
        initialValues={initialValues}
        validate={(values) => {
          const errors = {}        
          const parsedDeclaredValue = parseFloat(values[declaredValueLumpsumField], 10)
          if (Number.isNaN(parsedDeclaredValue)) {
            errors[declaredValueLumpsumField] = "Please enter a valid declared value lumpsum."
          } else {
            values[declaredValueLumpsumField] = parsedDeclaredValue
          }

          // make sure declaredValueLumpsum is bigger than the volumeofShipment * 2000
          const volumeOfShipment = parseFloat(values[volumeOfShipmentField], 10)
          if (Number.isNaN(volumeOfShipment)) {
            errors[volumeOfShipmentField] = "Please enter a valid volume of shipment."
          } else {
            values[volumeOfShipmentField] = volumeOfShipment
            const minimumValue = volumeOfShipment * 2000
            if (values[declaredValueLumpsumField] < minimumValue) {
              errors[declaredValueLumpsumField] = `The declared value lumpsum must be a minimum € 2000,00 for each cubic meter of shipment volume.`
            }
          }

          let sumShipmentItemsValue = 0;
          if (values[shipmentItemsField]) {
            values[shipmentItemsField].split('(').forEach((item, index) => {
              if (index === 0) {
                return
              }            
              const value = item.split(')')[0].trim()
              const parsedValue = parseFloat(value, 10)
              
              if (Number.isNaN(parsedValue)) {
                errors[shipmentItemsField] = "Please enter a valid item value for the shipment items."
              }           
              if (value === '') {
                errors[shipmentItemsField] = "Please enter a valid item value for the shipment items."
              }            
              sumShipmentItemsValue += parsedValue
            })
          }
          
          if (Number.isNaN(sumShipmentItemsValue)) {
            errors[shipmentItemsField] = "Please enter a valid item value for the shipment items."
          }

          const newTotalValue = (values[declaredValueLumpsumField] || 0) + sumShipmentItemsValue
          values[totalValueField] = newTotalValue
          setTotalValue(newTotalValue)

          formFields[1].forEach((item) => {
            if (
              values[`input_${item.id}`] !== undefined &&
              values[`input_${item.id}`] === '' &&
              item.isRequired
            ) {
              errors[`input_${item.id}`] = 'Is required'
            }

            if (
              values[`input_${item.id}`] !== undefined &&
              values[`input_${item.id}`] !== '' &&
              item.type === 'email' &&
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                values[`input_${item.id}`]
              )
            ) {
              errors[`input_${item.id}`] = 'Not a valid e-mailadres'
            }

            if (
              values[`input_${item.id}`] !== undefined &&
              values[`input_${item.id}`] !== '' &&
              item.type === 'phone' &&
              !isPossiblePhoneNumber(values[`input_${item.id}`])
            ) {
              errors[`input_${item.id}`] =
                'Invalid phone number, please choose a valid country'
            }

            if (
              values[`input_${item.id}`] !== undefined &&
              values[`input_${item.id}`] !== '' &&
              item.class === 'react-datepicker'
            ) {
              errors[`input_${item.id}`] = 'Date must be later than today'
            }
          })

          return errors
        }}

        onSubmit={async (values, { setSubmitting }) => {
          setSubmitting(true)

          const response = await handleSubmission(values)

          if (!response) {
            setSubmitting(false)
          }
        }}
      >
        {({ isSubmitting, setFieldValue, validateForm, handleSubmit, values, setFieldTouched }) => {
          if (isSubmitting || status === 'redirecting') {
            return (
              <LoadingWrapper>
                <Loading />
              </LoadingWrapper>
            )
          }

          if (status === 'error') {
            return (
              <div className="alert alert-danger">
                <p>There was an error submitting the form. Please try again later.</p>
              </div>
            )
          }

          if (status === 'done') {
            return <ParseContent content={message} />
          }

          return (
            <Form method="post" id={`form_${id}`}>
              <FormBox className="my-5">
                {formFields[1].map((item) => (
                  <Input
                    key={item.id}
                    item={item}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    initialValues={initialValues}
                    setData={setDataLocal}
                    data={data}
                  />
                ))}

                <div className='px-3 mt-4' style={{ fontWeight: 'bold', fontSize: 18 }}>Total declared value lumpsum: € {totalValue}</div>
              </FormBox>

              <div className="d-flex justify-content-end">
                <StyledButtonDefault isCustom>
                  <ButtonDefaultSubmit
                    type="submit"
                    onClick={() => {
                      handleSubmit()
                    }}
                  >
                    <span>Submit form</span>
                    <Next />
                  </ButtonDefaultSubmit>
                </StyledButtonDefault>
              </div>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}

export default LumpsumForm
